module.exports = __webpack_public_path__ + "img/question-circle.600debbd.svg";